import React from "react";

const PaymentPendingSummaryCard = ({
    data = {},
    onClick
}) => {

    // ==========================================
    // PAYMENT PENDING COUNTS
    // FROM DASHBOARD API
    // ==========================================

    const pendingBilling =
        Number(
            data?.totalPaymentPendingBilling || 0
        );

    const pendingPO =
        Number(
            data?.totalPaymentPendingPO || 0
        );

    const pendingHO =
        Number(
            data?.totalPaymentPendingHO || 0
        );

    const pendingAccounts =
        Number(
            data?.totalPaymentPendingAccounts || 0
        );


    const total =
        pendingBilling +
        pendingPO +
        pendingHO +
        pendingAccounts;


    // ==========================================
    // SUMMARY ITEMS
    // ==========================================

    const summaryItems = [
        {
            key: "billing",
            label: "Billing",
            value: pendingBilling,
            icon: "fa fa-file-invoice",
            subLabel: "Pending with Billing",
            background:
                "linear-gradient(135deg, #0d6efd 0%, #084298 100%)",
            iconBackground:
                "rgba(255,255,255,0.20)"
        },

        {
            key: "po",
            label: "PO",
            value: pendingPO,
            icon: "fa fa-shopping-cart",
            subLabel: "Pending with PO Team",
            background:
                "linear-gradient(135deg, #fd7e14 0%, #c75b00 100%)",
            iconBackground:
                "rgba(255,255,255,0.20)"
        },

        {
            key: "ho",
            label: "HO",
            value: pendingHO,
            icon: "fa fa-building",
            subLabel: "Pending with Head Office",
            background:
                "linear-gradient(135deg, #6f42c1 0%, #4c2a85 100%)",
            iconBackground:
                "rgba(255,255,255,0.20)"
        },

        {
            key: "accounts",
            label: "Accounts",
            value: pendingAccounts,
            icon: "fa fa-calculator",
            subLabel: "Pending with Accounts",
            background:
                "linear-gradient(135deg, #20c997 0%, #13795b 100%)",
            iconBackground:
                "rgba(255,255,255,0.20)"
        }
    ];


    // ==========================================
    // CLICK HANDLER
    // SAME EXISTING PAYMENT DASHBOARD
    // ==========================================

    const handleCardClick = () => {

        if (!onClick) return;

        onClick("payment");
    };


    return (

        <div
            className="card border-0 mb-3"
            style={{
                borderRadius: "16px",
                overflow: "visible",
                background: "transparent",
                boxShadow:
                    "0 6px 18px rgba(0,0,0,0.08)"
            }}
        >

            {/* ================= HEADER ================= */}

            <div
                className="
                    d-flex
                    justify-content-between
                    align-items-center
                    flex-wrap
                    gap-2
                "
                style={{
                    padding: "10px 14px 3px 14px"
                }}
            >

                <div>

                    <div
                        className="
                            d-flex
                            align-items-center
                            gap-2
                        "
                    >

                        <h4
                            className="mb-0"
                            style={{
                                fontSize: "17px",
                                fontWeight: 700,
                                color: "#212529"
                            }}
                        >
                            Payment Processing
                        </h4>


                        <span
                            className="badge"
                            style={{
                                background: "#6f42c1",
                                color: "#ffffff",
                                border:
                                    "1px solid #6f42c1",
                                fontSize: "9px",
                                padding: "4px 8px"
                            }}
                        >
                            NEW
                        </span>

                    </div>


                    <div
                        className="mt-1"
                        style={{
                            color: "#6c757d",
                            fontSize: "10px"
                        }}
                    >
                        Overview of pending payment actions
                    </div>

                </div>


                {/* ================= VIEW DETAILS ================= */}

                <button
                    type="button"
                    className="btn btn-sm"
                    onClick={handleCardClick}
                    style={{
                        color: "#343a40",
                        border:
                            "1px solid #ced4da",
                        borderRadius: "8px",
                        padding: "5px 11px",
                        fontSize: "11px",
                        fontWeight: 600,
                        boxShadow:
                            "0 2px 6px rgba(0,0,0,0.06)"
                    }}
                >
                    View Details
                </button>

            </div>


            {/* ================= BODY ================= */}

            <div
                style={{
                    padding: "7px 12px 18px"
                }}
            >

                <div className="row g-2">

                    {/* ================= TOTAL ================= */}

                    <div className="col-xl-3 col-lg-4 col-md-12">

                        <div
                            onClick={handleCardClick}
                            style={{
                                cursor: "pointer",
                                height: "100%",
                                minHeight: "100px",
                                borderRadius: "11px",
                                padding: "11px",
                                background:
                                    "linear-gradient(135deg, #343a40 0%, #212529 100%)",
                                border:
                                    "1px solid rgba(255,255,255,0.30)",
                                boxShadow:
                                    "0 6px 14px rgba(0,0,0,0.20)"
                            }}
                        >

                            <div
                                className="
                                    d-flex
                                    align-items-center
                                    gap-2
                                "
                            >

                                <div
                                    className="
                                        d-flex
                                        align-items-center
                                        justify-content-center
                                    "
                                    style={{
                                        width: "42px",
                                        height: "42px",
                                        borderRadius: "50%",
                                        background:
                                            "rgba(255,255,255,0.20)",
                                        flexShrink: 0
                                    }}
                                >

                                    <i
                                        className="fa fa-money-bill-wave"
                                        style={{
                                            fontSize: "18px",
                                            color: "#ffffff"
                                        }}
                                    />

                                </div>


                                <div>

                                    <div
                                        style={{
                                            fontSize: "25px",
                                            fontWeight: 700,
                                            lineHeight: 1,
                                            color: "#ffffff"
                                        }}
                                    >
                                        {total}
                                    </div>


                                    <div
                                        className="mt-1"
                                        style={{
                                            fontSize: "11px",
                                            fontWeight: 600,
                                            color: "#ffffff"
                                        }}
                                    >
                                        Total Pending
                                    </div>

                                </div>

                            </div>


                            <div
                                className="mt-2"
                                style={{
                                    fontSize: "9px",
                                    color:
                                        "rgba(255,255,255,0.90)"
                                }}
                            >
                                Total pending payment actions
                            </div>

                        </div>

                    </div>


                    {/* ================= STAGE CARDS ================= */}

                    <div className="col-xl-9 col-lg-8 col-md-12">

                        <div className="row g-2">

                            {summaryItems.map(
                                (summary) => (

                                    <div
                                        key={summary.key}
                                        className="
                                            col-xl-3
                                            col-lg-6
                                            col-md-6
                                            col-sm-6
                                        "
                                    >

                                        <div
                                            onClick={
                                                handleCardClick
                                            }
                                            style={{
                                                cursor: "pointer",
                                                height: "100%",
                                                minHeight: "100px",
                                                borderRadius:
                                                    "11px",
                                                padding: "10px",
                                                background:
                                                    summary.background,
                                                border:
                                                    "1px solid rgba(255,255,255,0.28)",
                                                boxShadow:
                                                    "0 6px 14px rgba(0,0,0,0.16)"
                                            }}
                                        >

                                            <div
                                                className="
                                                    d-flex
                                                    align-items-center
                                                    gap-2
                                                "
                                            >

                                                <div
                                                    className="
                                                        d-flex
                                                        align-items-center
                                                        justify-content-center
                                                    "
                                                    style={{
                                                        width: "38px",
                                                        height: "38px",
                                                        borderRadius:
                                                            "50%",
                                                        background:
                                                            summary.iconBackground,
                                                        flexShrink: 0
                                                    }}
                                                >

                                                    <i
                                                        className={
                                                            summary.icon
                                                        }
                                                        style={{
                                                            fontSize:
                                                                "16px",
                                                            color:
                                                                "#ffffff"
                                                        }}
                                                    />

                                                </div>


                                                <div>

                                                    <div
                                                        style={{
                                                            fontSize:
                                                                "21px",
                                                            fontWeight:
                                                                700,
                                                            lineHeight:
                                                                1,
                                                            color:
                                                                "#ffffff"
                                                        }}
                                                    >
                                                        {summary.value}
                                                    </div>


                                                    <div
                                                        className="mt-1"
                                                        style={{
                                                            fontSize:
                                                                "11px",
                                                            fontWeight:
                                                                600,
                                                            color:
                                                                "#ffffff"
                                                        }}
                                                    >
                                                        {summary.label}
                                                    </div>

                                                </div>

                                            </div>


                                            <div
                                                className="mt-2"
                                                style={{
                                                    fontSize:
                                                        "9px",
                                                    fontWeight:
                                                        500,
                                                    lineHeight:
                                                        "12px",
                                                    color:
                                                        "rgba(255,255,255,0.90)",
                                                    minHeight:
                                                        "12px"
                                                }}
                                            >
                                                {summary.subLabel}
                                            </div>

                                        </div>

                                    </div>

                                )
                            )}

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
};


export default PaymentPendingSummaryCard;